"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailAlertRecipientType = void 0;
var EmailAlertRecipientType;
(function (EmailAlertRecipientType) {
    EmailAlertRecipientType["AccountOwner"] = "accountOwner";
    EmailAlertRecipientType["AccountTeam"] = "accountTeam";
    EmailAlertRecipientType["CaseTeam"] = "caseTeam";
    EmailAlertRecipientType["CampaignMemberDerivedOwner"] = "campaignMemberDerivedOwner";
    EmailAlertRecipientType["ContactLookup"] = "contactLookup";
    EmailAlertRecipientType["Creator"] = "creator";
    EmailAlertRecipientType["CustomerPortalOwner"] = "customerPortalOwner";
    EmailAlertRecipientType["Email"] = "email";
    EmailAlertRecipientType["Group"] = "group";
    EmailAlertRecipientType["OpportunityTeam"] = "opportunityTeam";
    EmailAlertRecipientType["Owner"] = "owner";
    EmailAlertRecipientType["PartnerUser"] = "partnerUser";
    EmailAlertRecipientType["PortalRole"] = "portalRole";
    EmailAlertRecipientType["PortalRoleSubordinates"] = "portalRoleSubordinates";
    EmailAlertRecipientType["Role"] = "role";
    EmailAlertRecipientType["RoleSubordinates"] = "roleSubordinates";
    EmailAlertRecipientType["RoleSubordinatesInternal"] = "roleSubordinatesInternal";
    EmailAlertRecipientType["User"] = "user";
    EmailAlertRecipientType["UserLookup"] = "userLookup";
})(EmailAlertRecipientType || (exports.EmailAlertRecipientType = EmailAlertRecipientType = {}));
//# sourceMappingURL=PeriscopeSfEmailAlert.js.map